import { createMachine, assign, DoneInvokeEvent } from 'xstate';

import { Context, Events, GatewayConfig } from './types';

export const initialContext: Context = {
  serverHost: '',
  publicKey: null,
  securityToken: null,
  vaultCurrencies: null,
  defaultVaults: {
    creditCard: null,
  },
  requiredFields: {
    creditCard: [],
    bankAccount: [],
  },
  threeDSecure: {
    enabled: false,
  },
};

const paymentGateway = createMachine<Context, Events>({
  context: initialContext,
  predictableActionArguments: true,
  initial: 'initialization',
  states: {
    initialization: {
      invoke: {
        id: 'fetchConfig',
        src: 'getGatewayConfig',
        onDone: {
          target: 'ready',
          actions: assign(
            (_ctx, event: DoneInvokeEvent<GatewayConfig>) => event.data
          ),
        },
        onError: {
          target: 'error',
        },
      },
    },
    error: {},
    ready: {},
  },
});

export { paymentGateway };
